import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { getCurrentUser, signOut } from "aws-amplify/auth";
import LoginPage from "./components/LoginPage";
import ToolsHub from "./pages/ToolsHub";
import JobHunterApp from "./tools/job-hunter/JobHunterApp";

export default function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [dark, setDark] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  useEffect(() => {
    getCurrentUser()
      .then((u) => setUser(u))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);

  const handleLogout = async () => {
    await signOut();
    setUser(null);
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center">
        <div className="text-gray-400 animate-pulse">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage onLogin={() => getCurrentUser().then(setUser)} />;
  }

  return (
    <>
      {/* Top-right controls */}
      <div className="fixed top-4 right-4 z-50 flex gap-2">
        <button
          onClick={() => setDark((d) => !d)}
          className="px-3 py-1.5 text-xs rounded-lg bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700 transition-colors dark:bg-gray-700 dark:border-gray-600"
          title={dark ? "Light mode" : "Dark mode"}
        >
          {dark ? "Light" : "Dark"}
        </button>
        <button
          onClick={handleLogout}
          className="px-3 py-1.5 text-xs rounded-lg bg-gray-800 text-gray-300 border border-gray-700 hover:bg-gray-700 transition-colors dark:bg-gray-700 dark:border-gray-600"
        >
          Sign Out
        </button>
      </div>
      <Routes>
        <Route path="/" element={<ToolsHub />} />
        <Route path="/job-hunter/*" element={<JobHunterApp />} />
      </Routes>
    </>
  );
}
